// extracted by mini-css-extract-plugin
export default {"mainHead":"NavigationPage_mainHead__OG0p4","navigationButtons":"NavigationPage_navigationButtons__UhMnx","spinner":"NavigationPage_spinner__NVFRO"};